import React from 'react';
import { LogoAlign } from '@tink/config/src/tinkLinkConfig';
import { BackButton, CloseButton } from '../HeaderButton/HeaderButton';
import { StyledClientLogo, StyledHeader, StyledLogoContainer } from './Header.styles';

export type BackButton = { onBack: VoidFunction | undefined };

type GetRenderBackButtonPayload = {
  logoAlign: LogoAlign;
} & BackButton;

const getRenderBackButton = ({ onBack, logoAlign }: GetRenderBackButtonPayload) => {
  if (onBack) {
    return <BackButton onBack={onBack} />;
  }

  if (logoAlign === 'CENTER') {
    return <BackButton onBack={undefined} />;
  }

  return null;
};

export type HeaderMoleculeProps = {
  onClose: (() => Promise<void>) | undefined;
  addBottomMargin: boolean;
  clientName?: string;
  clientLogo: string;
  logoAlign: LogoAlign;
  hideLogo: boolean;
} & BackButton;

export const HeaderMolecule: React.FC<HeaderMoleculeProps> = ({
  onBack,
  onClose,
  addBottomMargin,
  clientName,
  clientLogo,
  logoAlign,
  hideLogo,
}) => {
  const showLogo = !hideLogo && clientLogo;

  return (
    <StyledHeader addBottomMargin={addBottomMargin}>
      {getRenderBackButton({ onBack, logoAlign })}

      <StyledLogoContainer logoAlign={logoAlign}>
        {showLogo && (
          <StyledClientLogo src={clientLogo} alt={clientName} data-testid="client-logo" />
        )}
      </StyledLogoContainer>

      <CloseButton onClose={onClose} />
    </StyledHeader>
  );
};
